import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CompareViewModel from "./viewModel";
import BaseLayout from "../../components/BaseLayout";
import EmptyRecordPage from "./containers/EmptyRecordPage";
import CompareItemTable from "./containers/CompareItemTable";

const Compare = () => {
  const { t } = useTranslation();
  const { pathname, compareItems, metaTitle, metaTags } = useContext(
    CompareViewModel.Context
  );

  return (
    <BaseLayout
      breadcrumbsItems={[
        { label: t("homepage"), to: `${process.env.PUBLIC_URL}/` },
        {
          label: t("compare.compare"),
          to: process.env.PUBLIC_URL + pathname,
        },
      ]}
      metaTitle={t("compare.metaTitle")}
      metaName={t("compare.metaName")}
      metaContent={t("compare.metaContent")}
      title={metaTitle}
      metaTags={metaTags}
    >
      <div className="compare-main-area pt-90 pb-100">
        <div className="container">
          {Array.isArray(compareItems) && compareItems.length >= 1 ? (
            <CompareItemTable />
          ) : (
            <EmptyRecordPage />
          )}
        </div>
      </div>
    </BaseLayout>
  );
};

export default CompareViewModel.withProvider(Compare);
